// extracted by mini-css-extract-plugin
module.exports = {"container":"Welcome_container__1dAWR"};